import { Dispatch } from 'redux';
import {
  CANCEL_POLICY_START,
  CANCEL_POLICY_SUCCESS,
  CANCEL_POLICY_FAILED,
  CANCEL_POLICY_MODAL,
  CANCEL_POLICY_REASON
} from './types';
import { ReduxStore } from '../payload-types';
import { ApiClient } from '../api.client';
import { LINKS } from '@trip-ux/constants';
import { map } from 'lodash';

export const cancelPoliciesWithOriginal =
  (policies: string[]) =>
  (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<unknown> => {
    dispatch({ type: CANCEL_POLICY_START });
    const state = getState();
    const province = state.policyInfo.selectedPolicies[0].tripInformation.provinceOfResidence;
    const requestPayload = {
      cancellationReason: state.cancelPolicy.cancellationReason,
      tripInformation: { provinceOfResidence: province },
      paxes: map(policies, policyNumber => ({ policyNumber }))
    };
    return apiClient(dispatch, getState)
      .put(LINKS.POLICY_CANCEL, requestPayload)
      .then(payload => {
        dispatch({ type: CANCEL_POLICY_SUCCESS, payload });
      })
      .catch(e => {
        dispatch({ type: CANCEL_POLICY_FAILED, payload: e });
      });
  };

export const showRefundModal =
  (payload: boolean) =>
  (dispatch: Dispatch): void => {
    dispatch({ type: CANCEL_POLICY_MODAL, payload });
  };

export const setCancellationReason =
  (payload: string) =>
  (dispatch: Dispatch): void => {
    dispatch({ type: CANCEL_POLICY_REASON, payload });
  };
